module.exports = __webpack_public_path__ + "static/img/xiazaijietu.156fdb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/xiazaijietu.png
// module id = WMrY
// module chunks = 24